import React, {useEffect} from "react";
import Routing from 'Routing';
import { ContestProvider } from 'modules/contexts/common/contestContext'
import { FilesProvider } from 'modules/contexts/common/filesContext'

import 'assets/styles/export.css'

import IdleTimer from 'modules/utils/IdleTimer'

import Loading from "components/common/Loading";
import {ParticipantProvider} from "./modules/contexts/common/participantContext";
import {JoinProvider} from "./modules/contexts/common/joinContext";
import {TeamProvider} from "./modules/contexts/common/teamContext";
import {BoardProvider} from "./modules/contexts/common/boardContext";
import {AdminProvider} from "./modules/contexts/common/adminContext";
import {RankingProvider} from "./modules/contexts/common/rankingContext";


//Provider list
// 상위 provider는 contexts아래의 하위 폴더명으로 이루어짐
const CommonProvider = ({ contexts, children }) =>
  contexts.reduce(
    (prev, context) =>
      React.createElement(context, {
        children: prev,
      }),
    children
  );

const App = () => {

  return (
    <>
     {/* 
        1. contexts의 하위 폴더 구조에 맞게 contexts를 구조화할 것
        2. contexts들은 왼쪽에서 오른쪽 순차적으로 run됨
      */}

      <CommonProvider contexts={[ContestProvider, AdminProvider, RankingProvider, FilesProvider,JoinProvider ,TeamProvider, BoardProvider, ParticipantProvider]}>
        <Loading />
        <Routing />
      </CommonProvider>
    </>
  );
};

export default App;
